<template>
  <header>
    <Container>
      <div class="header-inner">
        <div class="header-category-content">
          <div class="header-logo-wrap">
            <NuxtLink
                no-prefetch
                to="/"
                class="header-logo"
            />
            <UDropdown
                :items="dropDownData"
                :popper="{ placement: 'bottom-start' }"
                :ui="{
                shadow: 'shadow-xl',
                ring: 'ring-0',
                padding: 'p-0',
                item: {
                  padding: 'p-2.5',
                  active: 'bg-transparent cursor-auto',
                },
                width: 'w-56',
              }"
            >
              <template #default>
                <button
                    ref="dropdown"
                    class="header-button"
                />
              </template>
              <template #item="{ item }">
                <div
                    class="dropdown-item cursor-pointer w-full text-left px-2.5 py-1"
                >
                  <NuxtLink :to="item.link">
                    {{ item.label }}
                  </NuxtLink>
                </div>
              </template>
              <template #button>
                <div class="px-2.5 text-center py-2.5 w-full">
                  <UButton
                      :ui="{
                      rounded: 'rounded-full',
                      color: {
                        primary: {
                          outline:
                            'bg-[#f5f7f9] w-1/2 text-[#1774ff] text-bold ring-4 ring-[#1774ff] transition-color duration-[.4s] w-1/2 justify-center',
                        },
                      },
                    }"
                      block
                      variant="outline"
                      size="xl"
                      @click="showAuthModal = true"
                  >{{ $t('enterAndRegister') }}
                  </UButton
                  >
                </div>
              </template>
            </UDropdown>
          </div>
          <div class="header-container">
            <div class="header-category-select-wrap">
              <div
                  ref="categoryDropdown"
                  class="select-category-wrap"
                  @click="secondHeader = !secondHeader"
              >
                <p class="select-category-txt">{{ $t('allCategories') }}</p>
              </div>

            </div>
            <div ref="searchElement" class="header-search">
              <Search/>
            </div>
          </div>
        </div>
        <div class="header-btns">
          <UButton
              tag="div"
              no-prefetch
              class="header-favorite"
              @click="user ? navigateTo('/profile?page=profile-fav') : showAuthModal = true"
          />
          <div class="header-lang">
            <USelectMenu
                v-model="lang"
                :options="langOptions"
                variant="none"
                class="w-20 px-0 pe-1"
            />
          </div>
          <UserMenu
              v-if="user"
              style="margin-right: 10px"
              class="header-usermenu-avatar"
          />
          <UButton
              v-if="!user"
              class="login-btn"
              rounded
              size="xl"
              @click="showAuthModal = true"
          >{{ $t('login') }}
          </UButton
          >
          <UButton
              size="xl"
              icon="i-heroicons-plus-circle"
              class="header-apply-btn"
              @click="user ? (showCategoryModal = true) : (showAuthModal = true)"
          >{{ $t('applyAds') }}
          </UButton
          >
          <div class="flex items-center mobile-location" @click="toggleStateModal">
            <div class="mr-2 text-base">{{ currentState?.name || $t('usa') }}</div>
            <div class="header-geo-mobile"/>
          </div>

          <div
              class="header-bar"
              @click="toggleMobileMenu"
          ></div>
        </div>
      </div>

      <div style="position: relative">
        <OpenedHeader v-if="secondHeader || secondHeaderMobile"/>
      </div>
      <BreadCrumbs/>
    </Container>
    <div class="header-bottom-mobile">
      <div class="header-bottom-mobile-inner container">
        <NuxtLink no-prefetch to="/">
          <div class="header-bottom-mobile-main">
            <span>
              {{ $t('main') }}
            </span>
          </div>
        </NuxtLink>
        <div class="header-bottom-mobile-favorites" @click="user
              ? navigateTo({ path: '/profile', query: { page: 'profile-fav' } })
              : (showAuthModal = true)">
            <span>
              {{ $t('profile.fav') }}
            </span>
        </div>
        <div
            class="header-bottom-mobile-add"
            @click="user ? (showCategoryModal = true) : (showAuthModal = true)"
        ></div>
        <div class="header-bottom-mobile-notifications disabled">
          <span>
            {{ $t('notifications') }}
          </span>
        </div>
        <div
            :class="
            user ? 'header-bottom-mobile-profile' : 'header-bottom-mobile-login'
          "
            @click="
            user
              ? navigateTo({ path: '/profile', query: { page: 'profile-ads' } })
              : (showAuthModal = true)
          "
        >
          <span v-if="user">
            {{ $t('profile.profile') }}
          </span>
          <span v-else>
            {{ $t('login') }}
          </span>
        </div>
      </div>
    </div>
    <LazyAuthModal
        :show="showAuthModal"
        @close="showAuthModal = false"
    />
    <div
        v-if="isMenuMobileVisible"
        class="header-mobile-menu"
    >
      <div class="header-mobile-menu-top">
        <NuxtLink
            no-prefetch
            to="/"
            class="header-logo"
            @click="closeMobileMenu"
        ></NuxtLink>
        <div
            class="header-mobile-menu-close"
            @click="closeMobileMenu"
        ></div>
      </div>
      <div class="header-mobile-menu-lang">
        <UButton
            class="py-1.5 text-white hover:bg-blue-600 transition duration-200 header-mobile-menu-lang-btns"
            :class="locale == Locale.RU ? 'lang-btn-active' : 'lang-btn-inactive'"
            :ui="{ rounded: 'rounded-lg' }"
            @click="changeLang('ru')"
        >
          {{ $t('russian') }}
        </UButton>
        <UButton
            class="py-1.5 text-black hover:bg-blue-600 transition duration-200 header-mobile-menu-lang-btn header-mobile-menu-lang-btns"
            :class="locale == Locale.EN ? 'lang-btn-active' : 'lang-btn-inactive'"
            :ui="{ rounded: 'rounded-lg' }"
            @click="changeLang('en')"
        >
          {{ $t('english') }}
        </UButton>
      </div>
      <div class="header-mobile-menu-links">
        <div>
          <NuxtLink
              no-prefetch
              to="/for-business"
              @click="closeMobileMenu"
          >{{ $t('biziBusiness') }}
          </NuxtLink
          >
        </div>
        <div>
          <NuxtLink
              no-prefetch
              to="/paid-services"
              @click="closeMobileMenu"
          >{{ $t('paidServices') }}
          </NuxtLink
          >
        </div>
        <div>
          <NuxtLink
              no-prefetch
              to="/about-us"
              @click="closeMobileMenu"
          >{{ $t('aboutUs') }}
          </NuxtLink
          >
        </div>
        <div>
          <NuxtLink
              no-prefetch
              to="/privacy-policy"
              @click="closeMobileMenu"
          >
            {{ $t('privacyPolicy') }}
          </NuxtLink
          >
        </div>
        <div>
          <NuxtLink
              no-prefetch
              to="/help-feedback"
              @click="closeMobileMenu"
          >{{ $t('helpAndFeedback') }}
          </NuxtLink
          >
        </div>
      </div>
      <div class="header-mobile-menu-login">
        <UButton
            block
            class="py-1.5 header-mobile-menu-login-btn"
            :ui="{ rounded: 'rounded-lg' }"
            @click="user ? closeMobileMenuAndLogout() : closeMobileMenuAndLogin()"
        >
          {{ user ? $t('profile.logout') : $t('enterAndRegister') }}
        </UButton>
      </div>
    </div>
    <StateModal
        v-if="showStateModal"
        :show-mobile="showStateModal"
        @close="showStateModal = false"
    />
  </header>
</template>

<script lang="ts" setup>
import {onMounted, ref, inject, watch, onBeforeMount} from 'vue';
import {useUserStore} from '~/store/user';
import {storeToRefs} from 'pinia';
import OpenedHeader from './OpenedHeader.vue';
import useDetectOutsideClick from '~/composables/useDeteckOutsideClick';
import UserMenu from '../miscellaneous/UserMenu.vue';
import {PROVIDE_CATEGORY_MODAL_KEY} from '~/utils/defs';
import {useI18n} from 'vue-i18n';
import {Locale} from '@shared';
import type {IOptionsItem} from '~/types';
import {useAuthStore} from '~/store/auth';
import BreadCrumbs from './BreadCrumbs.vue';
import {useRouter} from '#vue-router';
import {useStateStore} from '~/store/state';

const categoryDropdown = ref<any>(null);
const categoryDropdownMobile = ref<any>(null);
const router = useRouter();
const showAuthModal = ref<boolean>(false);
const showCategoryModal = inject<Ref<boolean>>(PROVIDE_CATEGORY_MODAL_KEY);
const showStateModal = ref<boolean>(false);
const userStore = useUserStore();
const {user} = storeToRefs(userStore);
const secondHeader = ref<boolean>(false);
const secondHeaderMobile = ref<boolean>(false);
const stateStore = useStateStore();
const {currentState} = storeToRefs(stateStore);

const {t} = useI18n();
const dropDownData = ref<any>([
  [
    {label: t('marketingBizi'), link: 'for-business'},
    {label: t('paidServices'), link: 'paid-services'},
    {label: t('aboutUs'), link: 'about-us'},
  ],
]);
const {locale} = useI18n();
const {setItem, getItem} = useLocalStorage();

const isMenuMobileVisible = ref<boolean>(false);
const authStore = useAuthStore();

const toggleMobileMenu = () => {
  isMenuMobileVisible.value = !isMenuMobileVisible.value;
};
const closeMobileMenu = () => {
  isMenuMobileVisible.value = false;
};

const toggleStateModal = () => {
  showStateModal.value = !showStateModal.value;
};
const closeMobileMenuAndLogout = async () => {
  isMenuMobileVisible.value = false;
  await authStore.logout();
  await router.push({path: '/'});
};
const closeMobileMenuAndLogin = () => {
  isMenuMobileVisible.value = false;
  showAuthModal.value = true;
};

useDetectOutsideClick(categoryDropdown, () => {
  secondHeader.value = false;
});
useDetectOutsideClick(categoryDropdownMobile, () => {
  secondHeaderMobile.value = false;
});

const langOptions: IOptionsItem<string, Locale>[] = [
  {value: Locale.EN, label: 'EN'},
  {value: Locale.RU, label: 'RU'},
];

const lang = ref<IOptionsItem<string, Locale>>(
    langOptions.find((v) => v.value == locale.value) ?? langOptions[1],
);

watch(
    () => lang.value,
    (v: any) => {
      locale.value = v.value;
    },
);

watch(
    () => locale.value,
    (v: any) => {
      setItem(LOCALE_KEY, {"value":v,"label": v.toUpperCase()});
    },
);

const changeLang = (lang: string) => {
  locale.value = lang;
};

watch(
    () => user.value,
    (v) => {
      if (!v && !dropDownData.value[0].some((v: any) => v.slot == 'button'))
        dropDownData.value[0].push({slot: 'button', class: 'item-row'});
      else if (v && dropDownData.value[0].some((v: any) => v.slot == 'button'))
        dropDownData.value[0].splice(dropDownData.value[0].length - 1);
    },
    {immediate: true},
);

onBeforeMount(() => {
  const l = getItem(LOCALE_KEY, locale.value);
  if (l != locale.value) locale.value = l.value;
});

onMounted(() => {
  userStore.initUser();
});
</script>

<style lang="scss" scoped>

.header-bottom-mobile-notifications.disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: default;
}

.item-row:hover {
  cursor: auto;
  background-color: transparent !important;
}

.header-inner {
  display: flex;
  align-items: center;
  padding: 10px 0;
  justify-content: space-between;
  position: relative;
  gap: 10px;
}

.header-logo-wrap {
  display: flex;
  align-items: center;
  position: relative;
  gap: 10px;

  .header-button {
    margin-right: 10px;
    width: 24px;
    height: 24px;
    background: transparent url('../../assets/apps.svg') no-repeat center /
      auto;
  }
}

.header-dropdown-btn {
  margin-top: 20px;
}

.dropdown-item {
  cursor: pointer;
  font-size: 16px;
  line-height: 24px;
}

.header-logo {
  display: block;
  width: 50px;
  height: 50px;
  background: url('../../assets/logo.svg') no-repeat;
  background-position: left;
}

.header-favorite {
  cursor: pointer;
  width: 24px;
  height: 24px;
  background: url('../../assets/heart.svg') no-repeat center / auto;
}

.header-bell {
  cursor: pointer;
  width: 24px;
  height: 24px;
  background: url('../../assets/bell.svg') no-repeat center / auto;
}

.header-btns {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-btns button {
  height: 48px;
}

.header-btns > * {
  flex-shrink: 0;
}

.login-btn {
  color: var(--System-Button-Button-normal);
  background-color: var(--System-Button-Button-Ghost);
}

.header-login-button {
  padding: 13px var(--spacing_24);
  color: var(--System-Button-Button-normal);
  border-radius: 8px;
  background-color: var(--System-Button-Button-Ghost);
  margin-right: 10px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.langBtnActive {
  background-color: var(--Text-1000);
  color: #fff;
}

.ul-item {
  width: 100%;
  cursor: pointer;
  border-bottom: 1px solid #bebebe;
  align-items: center;
  padding: 5px;
}

.ul-item-last {
  width: 100%;
  cursor: pointer;
  align-items: center;
  padding: 5px;
}

.list-types {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  width: 100%;
}

.active {
  cursor: pointer;
  background-color: #ecf2ff;
}

.header-category-select-wrap {
  display: flex;
}

.header-category-content {
  display: flex;
  align-items: center;
  flex-grow: 1;
}

.select-category-wrap {
  cursor: pointer;
  position: relative;
  background: url('../../assets/vector-desktop.svg') no-repeat left 14px center / auto,
  url('../../assets/arrow.svg') no-repeat right 7px center / auto;
  background-color: var(--Background-Secondary) !important;
  padding: 12px 38px 12px 38px;
  border-radius: var(--radius_8);

  p {
    font-size: 16px;
    font-weight: 500;
  }
}

.header-bar {
  display: none;
}

.header-bottom-mobile {
  display: none;
}

.mobile-location,
.header-mobile-menu {
  display: none;
}

.header-geo-mobile {
  display: none;
  width: 24px;
  height: 24px;
  background-image: url('../../assets/geo-black.svg');
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  margin-right: 10px;
  background-size: contain;
}

@media screen and (max-width: 1200px) {
  .header-inner {
    justify-content: space-between;
  }
}

@media screen and (max-width: 650px) {

  .header-logo {
    background: url('../../assets/logo.svg') no-repeat;
    background-position: left;
  }
  .header-inner {
    position: relative;
    padding-bottom: 0;
  }
  .header-category-select-wrap {
    width: 100%;
    position: absolute;
    top: 55px;
    left: 0;
  }

  .select-category-wrap {
    align-content: start;
    background: url('../../assets/vector.svg') no-repeat left 14px center / auto,
    url('../../assets/arrow.svg') no-repeat right 7px center / auto;
  }
  .header-search {
    width: 100%;
  }
  .login-btn,
  .header-apply-btn,
  .header-favorite,
  .header-bell,
  .header-logo-wrap .header-button,
  .header-usermenu-avatar,
  .header-lang {
    display: none;
  }
  .header-geo-mobile {
    display: block;
  }
  .mobile-location {
    display: flex;
  }
  .header-bar {
    width: 32px;
    height: 32px;
    display: block;
    cursor: pointer;
    background: transparent url('../../assets/apps.svg') no-repeat center;
  }
  .header-bottom-mobile {
    display: block;
    position: fixed;
    bottom: 0;
    z-index: 3;
    box-shadow: 0px -0.5px 0.5px 0px #0000001a;
    width: 100%;
  }
  .header-bottom-mobile-inner {
    background: #fffffff5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 10px;
    color: #738291;
    font-size: 14px;
    line-height: 16px;
  }
  .header-bottom-mobile-main,
  .header-bottom-mobile-favorites,
  .header-bottom-mobile-notifications,
  .header-bottom-mobile-login,
  .header-bottom-mobile-profile {
    transition: color 0.3s ease, background-color 0.3s ease;
    cursor: pointer;
  }
  .header-bottom-mobile-main {
    background: url('../../assets/home.svg') no-repeat top center / auto;
  }
  .header-bottom-mobile-favorites {
    background: url('../../assets/heart.svg') no-repeat top center / auto;
  }
  .header-bottom-mobile-notifications {
    background: url('../../assets/bell.svg') no-repeat top center / auto;
  }
  .header-bottom-mobile-login {
    background: url('../../assets/login.svg') no-repeat top center / auto;
  }
  .header-bottom-mobile-profile {
    background: url('../../assets/user.svg') no-repeat top center / auto;
  }
  .header-bottom-mobile-favorites span,
  .header-bottom-mobile-main span,
  .header-bottom-mobile-notifications span,
  .header-bottom-mobile-login span,
  .header-bottom-mobile-profile span {
    display: block;
    padding-top: 25px;
  }
  .header-bottom-mobile-favorites:hover,
  .header-bottom-mobile-main:hover,
  .header-bottom-mobile-notifications:hover,
  .header-bottom-mobile-login:hover,
  .header-bottom-mobile-profile:hover {
    color: #0d6efd;
  }
  .header-bottom-mobile-favorites:hover {
    background: url('../../assets/heart-blue.svg') no-repeat top center / auto;
  }
  .header-bottom-mobile-main:hover {
    background: url('../../assets/home-blue.svg') no-repeat top center / auto;
  }
  .header-bottom-mobile-notifications:hover {
    background: url('../../assets/bell-blue.svg') no-repeat top center / auto;
  }
  .header-bottom-mobile-login:hover {
    background: url('../../assets/login-blue.svg') no-repeat top center / auto;
  }
  .header-bottom-mobile-profile:hover {
    background: url('../../assets/user-blue.svg') no-repeat top center / auto;
  }
  .header-bottom-mobile-add {
    cursor: pointer;
    background-color: #2bb671;
    background-image: url('../../assets/add.svg');
    background-repeat: no-repeat;
    background-position: center;
    width: 37px;
    height: 37px;
    padding: 8px;
    border-radius: 16px;
  }
  .header-mobile-menu {
    display: block;
    position: fixed;
    inset: 0;
    background-color: #fff;
    z-index: 3;
    padding: 16px 15px 10px;
  }
  .header-mobile-menu-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .header-logo {
    width: 52;
    height: 32px;
  }
  .header-mobile-menu-close {
    background: url('../../assets/close.svg') no-repeat center / auto;
    width: 32px;
    height: 32px;
    cursor: pointer;
  }
  .header-mobile-menu-lang {
    margin-top: 10px;
    margin-bottom: 30px;
    justify-content: right;
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .header-mobile-menu-lang-btns {
    width: 168px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lang-btn-active {
    background-color: #3b82f6 !important;
    color: white;
    transition: background-color 0.3s ease;
  }
  .lang-btn-inactive {
    background-color: #f0f3f5 !important;
    color: black;
    transition: background-color 0.3s ease;
  }
  .header-mobile-menu-lang-btn:hover {
    background-color: #dee1e3;
  }
  .header-mobile-menu-links {
    padding: 15px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    border-top: 1px solid #f5f4f6;
    border-bottom: 1px solid #f5f4f6;
    margin-bottom: 15px;
  }
  .header-mobile-menu-login-btn {
    background-color: #edf2ff;
    color: #1774ff;
  }
}

@media screen and (max-width: 568px) {
  .header-bottom-mobile-inner {
    font-size: 10px;
  }
}

@media screen and (max-width: 378px) {
  .header-mobile-menu-lang {
    justify-content: space-between;
  }
  .header-mobile-menu-lang-btn {
    margin-left: 0;
  }
}

.header-container {
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 10px;
}

.header-category-select-wrap {
  display: flex;
  width: 100%;
  margin: 0 auto;
}

.select-category-wrap {
  flex: none;
  text-align: center;
  cursor: pointer;
  max-width: 500px;
  width: 100%;
}

.header-search {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
